<mat-card class="cardT configuracoes-titulo">
  <span>Configurações</span>

  <span class="configuracoes-acoes">
    <button mat-icon-button type="button" matTooltip="Ajustes" [class.configuracoes-acao--ativa]="secao === 'campos'"
      [disabled]="secao === 'campos'" (click)="exibirSecao('campos')">
      <mat-icon>tune</mat-icon>
    </button>

    <button mat-icon-button type="button" matTooltip="Padrões de importação de cartão"
      [class.configuracoes-acao--ativa]="secao === 'padroes'" [disabled]="secao === 'padroes'" (click)="exibirSecao('padroes')">
      <mat-icon>credit_card</mat-icon>
    </button>

    <button mat-icon-button type="button" matTooltip="Formas de pagamento"
      [class.configuracoes-acao--ativa]="secao === 'formasPagamento'" [disabled]="secao === 'formasPagamento'"
      (click)="exibirSecao('formasPagamento')">
      <mat-icon>payments</mat-icon>
    </button>

    <button mat-icon-button type="button" matTooltip="Bancos" [class.configuracoes-acao--ativa]="secao === 'bancos'"
      [disabled]="secao === 'bancos'" (click)="exibirSecao('bancos')">
      <mat-icon>account_balance</mat-icon>
    </button>

    <button mat-icon-button type="button" matTooltip="Regras" [class.configuracoes-acao--ativa]="secao === 'regras'"
      [disabled]="secao === 'regras'" (click)="exibirSecao('regras')">
      <mat-icon>gavel</mat-icon>
    </button>
  </span>
</mat-card>

<div class="content" *ngIf="!loading && secao === 'campos'">
  <form [formGroup]="configFormGroup" class="content-body">
    <div class="input-group col-1">
      <mat-form-field appearance="outline">
        <mat-label>Número Celular Bot</mat-label>
        <input type="text" matInput formControlName="nrCelularBot" />
      </mat-form-field>
    </div>

    <div class="input-group col-3">
      <mat-form-field appearance="outline">
        <mat-label>Cor Rótulo Teste</mat-label>
        <input type="text" matInput [value]="obterCorTexto('dsCorTeste')" readonly />
        <button matSuffix type="button" mat-icon-button
          [matMenuTriggerFor]="colorMenu"
          (click)="abrirSeletorCor('dsCorTeste', 'Cor Teste')"
          matTooltip="Selecionar cor" [style.color]="obterCorPreview('dsCorTeste')">
          <mat-icon>palette</mat-icon>
        </button>
      </mat-form-field>
      <input type="hidden" formControlName="dsCorTeste" />
    </div>

    <div class="input-group col-1">
      <mat-form-field appearance="outline">
        <mat-label>Cor Mês Anterior</mat-label>
        <input type="text" matInput [value]="obterCorTexto('dsCorMesAnterior')" readonly />
        <button matSuffix type="button" mat-icon-button
          [matMenuTriggerFor]="colorMenu"
          (click)="abrirSeletorCor('dsCorMesAnterior', 'Cor Mês Anterior')" matTooltip="Selecionar cor"
          [style.color]="obterCorPreview('dsCorMesAnterior')">
          <mat-icon>palette</mat-icon>
        </button>
      </mat-form-field>
      <input type="hidden" formControlName="dsCorMesAnterior" />
    </div>

    <div class="input-group col-3">
      <mat-form-field appearance="outline">
        <mat-label>Cor Mês Atual</mat-label>
        <input type="text" matInput [value]="obterCorTexto('dsCorMesAtual')" readonly />
        <button matSuffix type="button" mat-icon-button
          [matMenuTriggerFor]="colorMenu"
          (click)="abrirSeletorCor('dsCorMesAtual', 'Cor Mês Atual')"
          matTooltip="Selecionar cor" [style.color]="obterCorPreview('dsCorMesAtual')">
          <mat-icon>palette</mat-icon>
        </button>
      </mat-form-field>
      <input type="hidden" formControlName="dsCorMesAtual" />
    </div>

    <div class="input-group col-1">
      <mat-form-field appearance="outline">
        <mat-label>Cor Mês Próximo</mat-label>
        <input type="text" matInput [value]="obterCorTexto('dsCorMesProximo')" readonly />
        <button matSuffix type="button" mat-icon-button
          [matMenuTriggerFor]="colorMenu"
          (click)="abrirSeletorCor('dsCorMesProximo', 'Cor Mês Próximo')"
          matTooltip="Selecionar cor" [style.color]="obterCorPreview('dsCorMesProximo')">
          <mat-icon>palette</mat-icon>
        </button>
      </mat-form-field>
      <input type="hidden" formControlName="dsCorMesProximo" />
    </div>

    <div class="buttons col-1-span-5">
      <button type="submit" color="primary" class="btn" mat-raised-button [disabled]="configFormGroup.invalid"
        (click)="onSalvar()">
        Salvar
      </button>
    </div>
  </form>

  <mat-menu #colorMenu="matMenu" [overlapTrigger]="false" panelClass="color-picker-menu">
    <ng-template matMenuContent>
      <color-picker
        (click)="$event.stopPropagation()"
        [(value)]="activeColorValue"
        [(format)]="activeColorFormat"
        (valueChange)="onActiveColorChange($event)"
      ></color-picker>
    </ng-template>
  </mat-menu>
</div>

<div *ngIf="loading" class="subscription">
  <div>
    <mat-spinner></mat-spinner>
    <p>Carregando...</p>
  </div>
</div>

<div class="subscription" *ngIf="subscription">
  <div>
    <mat-spinner></mat-spinner>
    <p>Salvando...</p>
  </div>
</div>

<app-padrao-importacao-cartao *ngIf="secao === 'padroes'"></app-padrao-importacao-cartao>
<app-formas-pagamento *ngIf="secao === 'formasPagamento'"></app-formas-pagamento>
<app-bancos *ngIf="secao === 'bancos'"></app-bancos>
<app-regras *ngIf="secao === 'regras'"></app-regras>
